// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Filters$ReactHooksTemplate = require("../dashboard/filters/filters.res.js");

function emptyState(param) {
  return {
          mode: "",
          count: 0,
          total: 0,
          percentage: 0.0
        };
}

function mode(t) {
  return t.mode;
}

function count(t) {
  return t.count;
}

function total(t) {
  return t.total;
}

function percentage(t) {
  return t.percentage;
}

function decodeDownloadReport(json) {
  return Json_decode.field("file_name", Json_decode.string, json);
}

function decode(json) {
  return {
          mode: Json_decode.field("mode", Json_decode.string, json),
          count: Json_decode.field("count", Json_decode.$$int, json),
          total: Json_decode.field("total", Json_decode.$$int, json),
          percentage: Json_decode.field("percentage", Json_decode.$$float, json)
        };
}

var Report = {
  emptyState: emptyState,
  mode: mode,
  count: count,
  total: total,
  percentage: percentage,
  decodeDownloadReport: decodeDownloadReport,
  decode: decode
};

var emptyReports = {
  mode: "",
  count: 0,
  total: 0,
  percentage: 0.0
};

var initialState = {
  loading: true,
  reports: emptyReports,
  toggleFilter: false
};

function reducer(state, x) {
  if (typeof x !== "object") {
    if (x === "FetchReportsInProgress") {
      return {
              loading: true,
              reports: state.reports,
              toggleFilter: state.toggleFilter
            };
    } else {
      return {
              loading: state.loading,
              reports: state.reports,
              toggleFilter: !state.toggleFilter
            };
    }
  } else {
    return {
            loading: false,
            reports: x._0,
            toggleFilter: state.toggleFilter
          };
  }
}

function ResponseModeReport(props) {
  var campaignId = props.campaignId;
  var match = React.useReducer(reducer, initialState);
  var dispatch = match[1];
  var match$1 = React.useState(function (param) {
        return /* [] */0;
      });
  var setReports = match$1[1];
  var toggleFilter = function (param) {
    Curry._1(dispatch, "ToggleFilter");
  };
  var url = "/api/v1/mode_wise_responses?campaign_id=" + campaignId;
  var fetchReport = function (param) {
    return Http$ReactHooksTemplate.fetchGetJSONDecode(url, (function (param) {
                  return Json_decode.field("mode_wise_count", (function (param) {
                                return Json_decode.list(decode, param);
                              }), param);
                }));
  };
  var onApplyFilter = function (param) {
    Curry._1(dispatch, "ToggleFilter");
    Curry._1(dispatch, "FetchReportsInProgress");
    Js_promise.then_((function (reports) {
            return Promise.resolve(Curry._1(setReports, (function (param) {
                              return reports;
                            })));
          }), fetchReport());
  };
  React.useEffect((function (param) {
          Js_promise.then_((function (reports) {
                  return Promise.resolve(Curry._1(setReports, (function (param) {
                                    return reports;
                                  })));
                }), fetchReport());
        }), []);
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                match[0].toggleFilter ? JsxRuntime.jsx(Filters$ReactHooksTemplate.make, {
                        onClose: toggleFilter,
                        onApply: onApplyFilter,
                        showDateFilter: false,
                        showFilterPills: false
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("h2", {
                                      children: "Response Mode Wise Report",
                                      className: "text-xl font-semibold"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsxs("button", {
                                              children: [
                                                JsxRuntime.jsx("img", {
                                                      className: "h-14-px mr-2-px",
                                                      src: Image$ReactHooksTemplate.filterButton
                                                    }),
                                                "Filters"
                                              ],
                                              className: "bg-ghostwhite border border-gray-400\n            shadow-inner flex rounded py-2 px-3 text-xs",
                                              id: "filters",
                                              onClick: (function (param) {
                                                  Curry._1(dispatch, "ToggleFilter");
                                                })
                                            }),
                                        JsxRuntime.jsxs("button", {
                                              children: [
                                                JsxRuntime.jsx("img", {
                                                      className: "h-14-px mr-1 filter-white",
                                                      src: Image$ReactHooksTemplate.download
                                                    }),
                                                "Download"
                                              ],
                                              className: "bg-pigmentblue border border-gray-400\n              flex rounded py-2 px-3 text-xs text-white",
                                              onClick: (function ($$event) {
                                                  $$event.preventDefault();
                                                  var download_url = "/api/v1/download_mode_wise_responses_report?campaign_id=" + campaignId;
                                                  Js_promise.then_((function (file_name) {
                                                          return Promise.resolve((console.log(file_name), RescriptReactRouter.push("/campaigns/report_downloads/" + campaignId)));
                                                        }), Http$ReactHooksTemplate.fetchGetJSONDecode(download_url, decodeDownloadReport));
                                                })
                                            })
                                      ],
                                      className: "flex gap-4"
                                    })
                              ],
                              className: "flex justify-between items-center p-20-px"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsxs("table", {
                                    children: [
                                      JsxRuntime.jsx("thead", {
                                            children: JsxRuntime.jsxs("tr", {
                                                  children: [
                                                    JsxRuntime.jsx("th", {
                                                          children: JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  "Mode",
                                                                  JsxRuntime.jsx("img", {
                                                                        className: "ml-4-px",
                                                                        src: Image$ReactHooksTemplate.heading
                                                                      })
                                                                ],
                                                                className: "flex"
                                                              }),
                                                          className: "px-4 py-2"
                                                        }),
                                                    JsxRuntime.jsx("th", {
                                                          children: JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  "Total Response (All Modes)",
                                                                  JsxRuntime.jsx("img", {
                                                                        className: "ml-4-px",
                                                                        src: Image$ReactHooksTemplate.heading
                                                                      })
                                                                ],
                                                                className: "flex"
                                                              }),
                                                          className: "px-4 py-2"
                                                        }),
                                                    JsxRuntime.jsx("th", {
                                                          children: JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  "Total Response (Individual Mode)",
                                                                  JsxRuntime.jsx("img", {
                                                                        className: "ml-4-px",
                                                                        src: Image$ReactHooksTemplate.heading
                                                                      })
                                                                ],
                                                                className: "flex"
                                                              }),
                                                          className: "px-4 py-2"
                                                        }),
                                                    JsxRuntime.jsx("th", {
                                                          children: JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  "Response %",
                                                                  JsxRuntime.jsx("img", {
                                                                        className: "ml-4-px",
                                                                        src: Image$ReactHooksTemplate.heading
                                                                      })
                                                                ],
                                                                className: "flex"
                                                              }),
                                                          className: "px-4 py-2"
                                                        })
                                                  ]
                                                }),
                                            className: "font-medium p-4 bg-ghostwhite text-aurometalsaurus"
                                          }),
                                      JsxRuntime.jsx("tbody", {
                                            children: $$Array.of_list(List.map((function (report) {
                                                        return JsxRuntime.jsxs("tr", {
                                                                    children: [
                                                                      JsxRuntime.jsx("td", {
                                                                            children: report.mode,
                                                                            className: "px-4 py-2"
                                                                          }),
                                                                      JsxRuntime.jsx("td", {
                                                                            children: String(report.total),
                                                                            className: "px-4 py-2"
                                                                          }),
                                                                      JsxRuntime.jsx("td", {
                                                                            children: String(report.count),
                                                                            className: "px-4 py-2"
                                                                          }),
                                                                      JsxRuntime.jsx("td", {
                                                                            children: report.percentage.toString(),
                                                                            className: "px-4 py-2"
                                                                          })
                                                                    ],
                                                                    className: "border-b border-bottom-gray-600"
                                                                  });
                                                      }), match$1[0]))
                                          })
                                    ],
                                    className: "text-left table-auto w-full border-separate text-xs font-medium"
                                  }),
                              className: "flex px-20-px"
                            })
                      ]
                    })
              ]
            });
}

var emptyReport = /* [] */0;

var make = ResponseModeReport;

exports.emptyReport = emptyReport;
exports.Report = Report;
exports.emptyReports = emptyReports;
exports.initialState = initialState;
exports.reducer = reducer;
exports.make = make;
/* react Not a pure module */
